<!-- <div *ngIf="loading" class="progressbar"></div> -->
<mat-spinner
  class="spinner"
  ProgressSpinnerMode="indeterminate"
  strokeWidth="6"
  diameter="50"
></mat-spinner>
